export const msalConfig = {
    auth: {
        clientId: `${process.env.REACT_APP_CLIENT_ID}`, 
        authority: "https://login.microsoftonline.com/67bff79e-7f91-4433-a8e5-c9252d2ddc1d", 
        redirectUri: `${process.env.REACT_APP_REDIRECT_URI}`, 
    },
    cache: {
        cacheLocation: "sessionStorage", 
        storeAuthStateInCookie: false, 
    },
};

export const loginRequest = {
    scopes: ["User.Read"], 
};
